import React from "react";

export const Header: React.FC = () => {
  return (
    <header className="hdr">
      <div className="hdr-inner">
        <h1 className="hdr-title">Lenia Parameter Explorer</h1>

        <p className="hdr-publication">
          <span className="full">
            Based on the publication:{" "}
            <em>Visualizing the Structure of Lenia Parameter Space</em>
          </span>
          <span className="short">
            <em>Visualizing the Structure of Lenia Parameter Space</em>
          </span>
        </p>

        <div className="hdr-credits">
          <p>
            App by{" "}
            <a
              href="https://fit.cvut.cz/en/faculty/people/19200-frantisek-dusek"
              target="_blank"
              rel="noreferrer"
            >
              František Dušek
            </a>
          </p>
          <p>
            Main author:{" "}
            <a
              href="https://www.barahudcova.com/"
              target="_blank"
              rel="noreferrer"
            >
              Barbora Hudcová
            </a>
          </p>
        </div>
      </div>

      <style>{`
        .hdr {
          position: sticky;
          top: 0;
          z-index: 20;
          padding: 0.75rem 1rem 0.5rem;
          background: color-mix(in srgb, var(--surface) 90%, transparent);
          backdrop-filter: blur(0.5rem);
          -webkit-backdrop-filter: blur(0.5rem);
        }

        .hdr::after {
          content: "";
          position: absolute;
          left: 0; right: 0; bottom: 0;
          height: 2px;
          background: linear-gradient(
            90deg,
            color-mix(in srgb, var(--header-gradient-start) 60%, transparent),
            color-mix(in srgb, var(--header-gradient-end) 60%, transparent)
          );
          opacity: 0.9;
        }

        .hdr-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 0.35rem;
        }

        .hdr-title {
          margin: 0;
          font-weight: 700;
          font-size: clamp(1.25rem, 2.2vw, 1.75rem);
          background: linear-gradient(135deg,
            var(--header-gradient-start),
            var(--header-gradient-end)
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1.1;
        }

        .hdr-sub {
          color: var(--muted);
          font-size: 0.8rem;
        }

        .hdr-publication {
          margin-top: 0.4rem;
          font-size: 0.75rem;
          color: var(--muted);
        }

        .hdr-publication .short {
          display: none;
        }

        .hdr-credits {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 1rem;
          margin-top: 0.25rem;
          font-size: 0.75rem;
          color: var(--muted);
        }

        .hdr-credits a {
          color: var(--accent);
          text-decoration: none;
        }

        .hdr-credits a:hover {
          text-decoration: underline;
        }

        @media (max-width: 40rem) {
          .hdr-publication .full { display: none; }
          .hdr-publication .short { display: inline; }
          .hdr-credits a {
            color: color-mix(in srgb, var(--transition) 30%, white 70%);
            font-weight: 500;
          }
        }

        @media (max-width: 35rem) {
          .hdr-sub { display: none; }
        }
      `}</style>
    </header>
  );
};
